const TopicOne = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1>Gaining Exposure to Global Commodities</h1>
        <p>
          Discover a flexible and easy way to trade the world’s most popular
          CFDs on Commodities including energies and metals, accessible straight
          within our advanced, high-performance web platforms.
        </p>
      </div>
    </div>
  );
};

export default TopicOne;
